<template>
    <div>
        <div style="color: #00ff96;font-size: 1rem">采购申请</div>
        <form :form="form">
          <div class="form-group-list1">
              <div class="form-group-list">
                <div class="form-group">
                    <SelectField
                            label="采购员"
                            id="type"
                            v-model="form.purchaserId"
                            :options="userList"
                            required
                            labelWidth="40%"
                            @update:modelValue="(value) => handleModelValueUpdate('purchaserId', value)"
                    />
                </div>
                <div class="form-group">
                    <DatePickerField labelWidth="40%" label="采购时间"
                                     required name="purchaseTime" placeholder="请选择日期"
                                     :rules="[{ required: true, message: '请选择日期' }]"
                                     v-model="form.purchaseTime"
                                     id="purchaseTime"
                                     @update:modelValue="(value) => handleModelValueUpdate('purchaseTime', value)"
                    />
                </div>
              </div>
              <div class="form-group-list">
                  <TextareaField :value="form.reason" required id="reason"
                                 labelWidth="15%" style="margin: 0.5rem 0.2rem" label="申请原因"
                                 @update:modelValue="(value) => handleModelValueUpdate('reason', value)"
                  />
              </div>

              <div class="form-group-list">
                  <TextareaField :value="form.remark" id="remark"
                                 labelWidth="15%" style="margin: 0.5rem 0.2rem" label="备注"
                                 @update:modelValue="(value) => handleModelValueUpdate('remark', value)"
                  />
              </div>

              <div class="form-group-list">
                  <div class="form-group form-group1">
                      <div style="width: 12%;margin-left: 1rem;">附件</div>
                      <div><Upload :list="fileList" @change="(list) => (fileList = list)" /></div>
                  </div>
              </div>
              <div class="form-group-list">
                  <div class="form-group form-group1">
                      <div style="width: 15%;margin-left: 1rem;">资产清单</div>
                      <div style="width: 95%"><Goods :list="materialList" /></div>
                  </div>
              </div>
          </div>

          <div class="center" style="margin: 1rem 0 0 0;">
            <a-space>
                <ButtonField text="关闭" @click="cancel" secondary />
                <ButtonField text="提交" primary @click="handleSubmit"/>
            </a-space>
          </div>
        </form>
    </div>
</template>

<script>
import { add } from "../api/buy";
import Goods from "./components/goods.vue";
import { mapState } from "vuex";
export default {
  components: {
    Goods,
  },

  data() {
    return {
      form: {
          purchaserId:null,
          purchaseTime:null,
          reason:null,
          remark:null
      },
      materialList: [],
      fileList: [],
      loading: false,
    };
  },

  computed: {
    ...mapState("userSelector", ["userList"]),
  },

  methods: {
    handleModelValueUpdate(fieldName, value) {
        this.form[fieldName] = value;
    },
    handleSubmit() {
        if (this.isSubmitting) return;
        this.isSubmitting = true;
        if (!this.form.purchaserId) {
            this.$message.error('采购员不能为空');
            this.isSubmitting = false;
            return;
        }
        if (!this.form.purchaseTime) {
            this.$message.error('采购时间不能为空');
            this.isSubmitting = false;
            return;
        }
        if (!this.form.reason) {
            this.$message.error('申请原因不能为空');
            this.isSubmitting = false;
            return;
        }
        add({
          ...this.form,
          purchaser: this.userList.find(
            (item) => item.id === this.form.purchaserId
          ).name,
          purchaseTime: this.form.purchaseTime.format("YYYY-MM-DD"),
          materialList: this.materialList,
          attachments: this.fileList.map((item) => item.id).join(","),
        }).then(() => {
            this.cancel();
        })
        .finally(() => {
          this.isSubmitting = false;
        });

    },
    cancel() {
        this.$emit('show-index');
    },
  },
};
</script>
<style scoped>
.form-group-list{
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin: 0.5rem 0;
}
.form-group{
    width: 100%;
    margin-right: 1rem;
}
.form-group1{
    display: flex;
    justify-content: start;
    align-content: center;
    color: #93A2B7FF;
}
</style>



